import { FC, memo, PropsWithChildren, ReactNode } from 'react';
import classNames from 'classnames';
// Import UI Components
import { ModuleTitle, Paper } from '@geneui/components';
// Import Styles
import styles from './sectionWithTitle.module.scss';

interface SectionWithTitleProps {
    title: string | ReactNode;
    titleContent?: ReactNode;
    className?: string;
    contentClassName?: string;
    hasShadow?: boolean;
    hasContentPadding?: boolean;
    hasFullHeight?: boolean;
    hasTitleBorder?: boolean;
    hasTitleAndContentSeparator?: boolean;
    hideTitleUnderline?: boolean;
}

const SectionWithTitle: FC<PropsWithChildren<SectionWithTitleProps>> = (props) => {
    const {
        children,
        title,
        titleContent,
        className,
        contentClassName,
        hasShadow = false,
        hasContentPadding = true,
        hasFullHeight = false,
        hasTitleBorder = true,
        hasTitleAndContentSeparator = true,
        hideTitleUnderline = false,
    } = props;

    return (
        <Paper
            className={classNames(
                {
                    [styles.fullHeight]: hasFullHeight,
                    [styles.hideTitleUnderline]: hideTitleUnderline,
                },
                styles.mainContainer,
                className,
            )}
            shadow={hasShadow}
            paperDirection="column"
            cornerRadius="full-radius"
            border={true}
        >
            <ModuleTitle
                className={classNames({ [styles.hideBorderBottom]: !hasTitleAndContentSeparator })}
                title={title}
                hideBeforeBorder={!hasTitleBorder}
            >
                {titleContent}
            </ModuleTitle>
            <div
                className={classNames({ [styles.contentPadding]: hasContentPadding }, styles.content, contentClassName)}
            >
                {children}
            </div>
        </Paper>
    );
};

export default memo(SectionWithTitle);
